import { ProfileOutlined } from "@ant-design/icons";
import { Avatar, Card, Divider, InputNumber, List, Space, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useCollection } from "../../../hooks/useCollection";

//modal for updating user
import UpdateUserModal from "./UpdateUserModal";

const { Title, Text } = Typography;
const { Meta } = Card;

export default function Users() {
   //gets users data from useCollection hook
   const { data: usersData, loading: usersLoading } = useCollection("users");

   //state for the user data
   const [allUsers, setAllUsers] = useState(null);
   const [loadingUsers, setLoadingUser] = useState(true);

   //updates state
   useEffect(() => {
      setAllUsers(usersData);
      setLoadingUser(usersLoading);
      console.log(usersData);
   }, [usersData, usersLoading]);

   //shows spin if data loading
   if (loadingUsers) {
      return <Spin />;
   }

   //return for each user in the list
   const userDisplay = (item) => {
      return (
         <Card style={{ width: 280 }} actions={[<UpdateUserModal user={item} key="edit" />]}>
            <Space size="large" direction="vertical">
               <Meta avatar={<Avatar src={item.imageUrl && item.imageUrl} />} title={item.name} description={item.email} />

               <Space>
                  <Text>Percent</Text>
                  <InputNumber disabled value={item.extraPercentage} />
               </Space>
            </Space>
         </Card>
      );
   };

   return (
      <div style={{ padding: "15px" }}>
         <Title level={3}>
            <ProfileOutlined />
            <Divider type="vertical" />
            User Profiles
         </Title>
         <Divider />
         <List
            grid={{
               column: 4,
            }}
            dataSource={allUsers}
            renderItem={(item) => <List.Item>{userDisplay(item)}</List.Item>}
         />
      </div>
   );
}
